export default "__VITE_ASSET__BKOxfLGl__"